define('util/http',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.deleteUrl = exports.postJson = exports.getJson = void 0;
    function getJson(url) {
        // Wrap XHR in promise
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        try {
                            var json = JSON.parse(xhr.responseText);
                            resolve(json);
                        }
                        catch (error) {
                            reject("GET invalid JSON " + xhr.responseText);
                        }
                    }
                    else if (xhr.status === 0) {
                        reject("connection failed");
                    }
                    else {
                        reject("GET failed status " + xhr.status);
                    }
                }
            };
            xhr.send();
        });
    }
    exports.getJson = getJson;
    /**
     * Post JSON to an endpoint, and parse the response as JSON
     */
    function postJson(url, payload) {
        // Wrap XHR in promise
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        try {
                            var json = JSON.parse(xhr.responseText);
                            resolve(json);
                        }
                        catch (error) {
                            reject("POST invalid JSON " + xhr.responseText);
                        }
                    }
                    else if (xhr.status === 0) {
                        reject("connection failed");
                    }
                    else {
                        try {
                            var json = JSON.parse(xhr.responseText);
                            if (json && json.error) {
                                reject(json.error);
                            }
                            else {
                                reject("status " + xhr.status);
                            }
                        }
                        catch (error) {
                            reject("invalid json " + xhr.responseText);
                        }
                    }
                }
            };
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(payload));
        });
    }
    exports.postJson = postJson;
    /**
     * Http delete endpoint, anything except 200 is rejected
     */
    function deleteUrl(url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("DELETE", url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve();
                    }
                    else {
                        reject("Delete failed status " + xhr.status);
                    }
                }
            };
            xhr.send();
        });
    }
    exports.deleteUrl = deleteUrl;
});
//# sourceMappingURL=/assets/javascripts/util/http.js.map;
